// import ManualDeductionButton from './manual-deduction-button.vue'
import ReductionButton from './reduction-button.vue';
import AssistButton from './assist-button.vue';
// import RobberyButton from './robbery-button.vue'
import LeaveCaseButton from './leave-case-button.vue';
import TurnSourceButton from './turn-source-button.vue';
import PauseButton from "./pause-button.vue";
import WarehousingApplicationButton from "./warehousing-application-button.vue";
import RepaymentButton from "./repayment-button.vue";
import ContractFormationButton from "./contract-formation-button.vue";
import { MENU_CHANNEL } from '~/config/enum.config';
export var componentsButton = {
    LeaveCaseButton: LeaveCaseButton,
    AssistButton: AssistButton,
    ReductionButton: ReductionButton,
    PauseButton: PauseButton,
    // RobberyButton,
    TurnSourceButton: TurnSourceButton,
    // ManualDeductionButton,
    WarehousingApplicationButton: WarehousingApplicationButton,
    RepaymentButton: RepaymentButton,
    ContractFormationButton: ContractFormationButton
};
export var buttonList = [
    {
        name: 'leave-case-button',
        auth: []
    },
    {
        name: 'assist-button',
        auth: []
    },
    {
        name: 'reduction-button',
        auth: []
    },
    {
        name: 'pause-button',
        auth: []
    },
    // {
    //   name: 'robbery-button',
    //   auth: []
    // },
    {
        name: 'turn-source-button',
        auth: []
    },
    // {
    //   name: 'manual-deduction-button',
    //   auth: []
    // },
    {
        name: 'warehousing-application-button',
        auth: [MENU_CHANNEL.Visit_personal, MENU_CHANNEL.Visit_team, MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team]
    },
    {
        name: 'repayment-button',
        auth: []
    },
    {
        name: 'contract-formation-button',
        auth: []
    }
];
